"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _keyframes = _interopRequireDefault(require("./keyframes"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    width: 27px;\n    height: 27px;\n    top: 0;\n    left: 30px;\n    border-radius: 50%;\n    ", ";\n    animation: ", " 1s ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme;
  var palette = theme.palette;
  return {
    backgroundColor: theme.animationBackgroundColor,
    transition: "opacity 2s ".concat(palette.transitionFunction, ", transform 1s ").concat(palette.transitionFunction)
  };
};

var Ripple = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
}, _keyframes["default"], function (props) {
  return props.theme.palette.transitionFunction;
});

var _default = Ripple;
exports["default"] = _default;